module.exports = __webpack_public_path__ + "assets/img/image1.6a772968.png";